import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { render } from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';

import { ROOT_ELEMENT_SELECTOR } from './consts';
import ErrorBoundary from './ErrorBoundary';
import initializeApp from './initializeApp';
import { ReactQueryProvider } from './ReactQuery';
import { store } from './redux';
import Routes from './routes';

//  Import root CSS.
import './styles/fossa.less';
import 'react-table/react-table.css';
import 'react-toggle/style.css';
import 'quill/dist/quill.snow.css';

import { theme } from './theme/mui-theme';

//  Handle any one-time app setup items.
initializeApp();

//  Root of the application.
const App = () => (
  <ErrorBoundary>
    <ReactQueryProvider>
      <ReduxProvider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Routes />
          </ThemeProvider>
        </StyledEngineProvider>
      </ReduxProvider>
    </ReactQueryProvider>
  </ErrorBoundary>
);

//  Render the app to the root element in the DOM.
render(
  <App />,
  document.querySelector(ROOT_ELEMENT_SELECTOR),
);
